import { Person } from '@weave/schema-gen-ts/dist/schemas/persons/v3/persons.pb';
import { InvoiceModel } from '@frontend/api-invoices';
import { contextFactory, MultiStepControl } from '@frontend/design-system';
import { CareCreditPatientData } from '../../../types/care-credit.types';
import {
  EnrollmentConfirmationData,
  EnrollmentFormState,
  EnrollmentFormFieldNames,
  ConfirmEnrollmentApplicationResponse,
  EnrollmentApplicationResponse,
  ConfirmEnrollmentProps,
} from '../enrollment-multi-step.types';

export type CareCreditEnrollmentContextState = {
  person: Person | undefined;
  invoice: InvoiceModel | undefined;
  careCreditData: CareCreditPatientData | undefined;
  enrollmentFormData: EnrollmentFormState;
  confirmationStepData: EnrollmentConfirmationData;
  applicationResult: EnrollmentApplicationResponse | undefined;
  applicationConfirmationResult: ConfirmEnrollmentApplicationResponse | undefined;
  isLoading: boolean;
  isSubmitting: boolean;
  multiStep: MultiStepControl;
  locationId: string | undefined;

  /**
   * Prop callback added to state.
   */
  onGoToMessageStep: () => void;

  setEnrollmentFormData: React.Dispatch<React.SetStateAction<EnrollmentFormState>>;
  onChangeEnrollmentFormField: (field: EnrollmentFormFieldNames, value: string) => void;
  onChangeEnrollmentFormComplete: (isComplete: boolean) => void;
  onClearIdFields: () => void;
  setConfirmationStepData: React.Dispatch<React.SetStateAction<EnrollmentConfirmationData>>;

  /**
   * Leave all flows entirely / close modal
   */
  onCancel: (() => void) | undefined;

  /**
   * Leave CareCredit Enrollment flow.
   * (i.e go back to payment methods step)
   */
  onGoBack: () => void;

  /**
   * Handle submit for pre-qualification
   */
  onSubmitApplication: (data: EnrollmentFormState) => Promise<EnrollmentApplicationResponse>;

  /**
   * Handle submit for application confirmation
   */
  onConfirmApplication: (data: ConfirmEnrollmentProps) => Promise<ConfirmEnrollmentApplicationResponse>;

  /**
   * Final step: Go to CareCredit collect step
   */
  onGoToCareCreditCollect: (data: ConfirmEnrollmentApplicationResponse) => void;
  onEnrollmentDeclined: (data: ConfirmEnrollmentApplicationResponse) => void;
};

export const [CareCreditEnrollmentContext, useCareCreditEnrollmentContext] =
  contextFactory<CareCreditEnrollmentContextState>('', {} as CareCreditEnrollmentContextState);
